import { useRef } from "react";
import { ArrowButton } from "../../../../../../components/features/ArrowButton";
import { useTranslation } from "../../../../../../lib/i18n";
import { ProfilerProduct } from "../../../../types/ProfilerProduct";
import { OtherProductCard } from "../../OtherProductCard";

type BeautyProfilerBeautyRitualProps = {
  topOtherProduct: {
    topGlamliner: ProfilerProduct | null;
    topOtherProducts: ProfilerProduct[];
  };
};

export const BeautyProfilerBeautyRitual = ({
  topOtherProduct,
}: BeautyProfilerBeautyRitualProps) => {
  const scrollContainerRef = useRef<HTMLDivElement | null>(null);
  const { t } = useTranslation();

  return (
    <>
      <div className="flex flex-col">
        <p className="text-[#CE0A2C] text-center font-garamond-italic text-[24px] italic font-normal">
          {t('results.beauty.personalizedRitual')}
        </p>
        <h1 className="text-[#050505] text-center font-bebas-kai text-[40px] font-normal">
          {t('results.beauty.beautyRitual')}
        </h1>
        <p className="text-[#050505] text-center font-garamond-italic text-[26px] italic font-normal">
          {t('results.beauty.with')}
        </p>
      </div>
      <div className="flex justify-between items-end self-stretch">
        <p className="text-[#050505] text-center font-garamond-italic text-[22px] italic font-normal">
          {t('results.beauty.lipsSignature')}
        </p>
        <ArrowButton
          ariaLabel={t('scrollProductsRight')}
          scrollContainerRef={scrollContainerRef}
        />
      </div>
      <div className="flex w-full">
        <div
          ref={scrollContainerRef}
          className="flex overflow-x-auto gap-4 w-full justify-evenly"
        >
          <OtherProductCard
            name={topOtherProduct.topGlamliner?.label}
            imagePath={`/beauty-profiler/other-products/${topOtherProduct.topGlamliner?.id}.avif`}
          />
          <OtherProductCard
            name={topOtherProduct.topOtherProducts[0]?.label}
            imagePath={`/beauty-profiler/other-products/${topOtherProduct.topOtherProducts[0]?.id}.avif`}
          />
          <OtherProductCard
            name={topOtherProduct.topOtherProducts[1]?.label}
            imagePath={`/beauty-profiler/other-products/${topOtherProduct.topOtherProducts[1]?.id}.avif`}
          />
        </div>
      </div>
    </>
  );
};
